// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FNDT","content":"styles_content__34rw2"};